import React from "react";
import { FaFacebookF, FaInstagram, FaWhatsapp } from "react-icons/fa";
import "../Footer/Footer.css";

import { Link } from "react-router-dom";
import { IoCall } from "react-icons/io5";

const Footer = () => {
  const callAdmin = () => {
    window.location.href = "tel:02033557350  ";
  };

  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Logo & Contact */}
        <div className="footer-col">
          <img src="/logo.webp" alt="Logo" className="footer-logo" />
          <p className="footer-description">
            Your premium travel partner for unforgettable journeys and exclusive
            experiences.
          </p>
          {/*--
          <div className="social-links">
        
            <a
              href="https://facebook.com"
              target="_blank"
              rel="noopener noreferrer"
              className="social-link"
            >
              <FaFacebookF />
            </a>
            <a
              href="https://instagram.com"
              target="_blank"
              rel="noopener noreferrer"
              className="social-link"
            >
              <FaInstagram />
            </a>
           
            <a
              href="https://api.whatsapp.com/send/?phone=447700172170&text=Hello+Click4Flight%21+I%27d+like+to+inquire+about+travel+options.&type=phone_number&app_absent=0"
              target="_blank"
              rel="noopener noreferrer"
              className="social-link"
            >
              <FaWhatsapp />
            </a>
            
          </div>
           --*/}
        </div>

        {/* Navigation Links */}
        <div className="footer-col">
          <h3>Navigation</h3>
          <ul>
            <li>
              <Link to="/">Home</Link>
            </li>
            <li>
              <Link to="/flight">Destinations</Link>
            </li>
            <li>
              <Link to="/holidays">Holidays</Link>
            </li>
            <li>
              <Link to="/aboutus">About</Link>
            </li>
            <li>
              <Link to="/contactus">Contact</Link>
            </li>
          </ul>
        </div>

        {/* Popular Destinations */}
        <div className="footer-col">
          <h3>Top Destinations</h3>

          <ul>
            <li>
              <Link to="/flight/usa"> USA</Link>
            </li>

            <li>
              <Link to="/flight/canada"> Canada</Link>
            </li>
            <li>
              <Link to="/flight/caribbean"> Caribbean</Link>
            </li>
            <li>
              <Link to="/flight/latin-america"> Latin America</Link>
            </li>
            <li>
              <Link to="/flight/a&n"> Australia & New Zealand</Link>
            </li>
          </ul>
        </div>

        {/* Social & Legal */}
        <div className="footer-col">
          <h3>Legal</h3>
          <ul>
            <li>
              <Link to="/privacy-policy">Privacy Policy</Link>
            </li>
            <li>
              <Link to="/terms&conditions">Terms & Conditions</Link>
            </li>
          </ul>
          <h3>Connect With Us</h3>
          <div className="social-icons">
            <button className="call-button" onClick={callAdmin}>
              <IoCall /> 02033557350
            </button>
          </div>
        </div>
      </div>

      {/* Copyright with Payment Methods */}
      <div className="footer-bottom">
        <p className="footer-bottom-text">
          “Click4Flight is a proud partner of the Journey Experts Ltd Group
          Company Registration No. 08596028"
        </p>
        <div className="copyright-container">
          <div className="copyright-text">
            <p>
              © {new Date().getFullYear()} Click4Flight | All rights reserved.
            </p>
            <p>
              Designed by{" "}
              <a
                href="https://infogainsoft.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                Infogainsoft
              </a>
            </p>
          </div>
          <div className="footer-center-logos">
            <img src="/atol.webp" alt="Logo 1" />
            {/*--<img src="/iata-logo.webp" alt="Logo 2" />--*/}
          </div>

          <div className="payment-methods">
            <img src="/visa.webp" alt="Visa" className="payment-icon" />
            <img
              src="/mastercard.webp"
              alt="MasterCard"
              className="payment-icon"
            />
            <img
              src="/american.webp"
              alt="American Express"
              className="payment-icon"
            />
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
